// src/pdfs/generateMembershipCard.js
import jsPDF from "jspdf";
import QRCode from "qrcode";
import sealImage from "../assets/seal.png";
import signatureImage from "../assets/signature.png";

// ✅ Single default export here only
export default async function generateMembershipCard(member) {
  const doc = new jsPDF();

  // Outer border
  doc.setDrawColor(0);
  doc.setLineWidth(0.3);
  doc.rect(10, 10, 190, 135);

  let y = 22;

  // Header
  doc.setFont("Times", "Bold");
  doc.setFontSize(12);
  doc.setTextColor("#0a3d91");
  doc.text("SHINE AGRI ALLIED AND MARKETING", 105, y, { align: "center" });
  y += 6;
  doc.text("MULTISTATE COOPERATIVE SOCIETY LIMITED", 105, y, { align: "center" });

  y += 5;
  doc.setFontSize(9);
  doc.setFont("Times", "Normal");
  doc.setTextColor("black");
  doc.text("48, 1st Floor, Amar Arcade, Nilpur, Ta-Dantiwada,", 105, y, { align: "center" });
  y += 4;
  doc.text("Dist-Banaskantha, Gujarat – 385505", 105, y, { align: "center" });
  y += 4;
  doc.text("Mo. +91 84908 84020, 93133 99225", 105, y, { align: "center" });

  // Title
  y += 8;
  doc.setFont("Times", "Bold");
  doc.setFontSize(11);
  doc.setTextColor("#0a3d91");
  doc.text("MEMBERSHIP CARD", 105, y, { align: "center" });

  // Body
  y += 10;
  doc.setFontSize(10);
  doc.setTextColor("black");
  doc.setFont("Times", "Normal");
  doc.text("This is to certify that", 20, y);

  y += 6;
  doc.setFont("Times", "Bold");
  const nameLines = doc.splitTextToSize(member.name.toUpperCase(), 150);
  doc.text(nameLines, 20, y);
  y += nameLines.length * 5;

  doc.setFont("Times", "Normal");
  doc.text(`Membership No.: ${member.member_id}`, 20, y);
  y += 6;

  const lines = [
    `is a bonafide member of Shine Agri Allied and Marketing`,
    `Multistate Cooperative Society Ltd. entitled to all rights and`,
    `benefits as per the society bylaws.`,
  ];
  lines.forEach(line => {
    doc.text(line, 20, y);
    y += 5;
  });

  const today = new Date();
  const issueDate = `${today.getDate().toString().padStart(2, "0")}/${(today.getMonth() + 1).toString().padStart(2, "0")}/${today.getFullYear()}`;
  doc.text(`Date of Issue: ${issueDate}`, 20, y);
  y += 5;

  // QR Code
  const qrText = `Membership No: ${member.member_id}\nName: ${member.name}`;
  const qrImage = await QRCode.toDataURL(qrText);
  doc.addImage(qrImage, "PNG", 150, 45, 40, 40);

  // Seal & Signature
  y += 30;
  doc.setFont("Times", "Normal");
  doc.text("Office Seal", 20, y);
  doc.text("Authorized Signatory", 145, y);

  doc.addImage(sealImage, "PNG", 18, y - 30, 30, 30);
  doc.addImage(signatureImage, "PNG", 135, y - 20, 40, 18);

  // Save
  doc.save(`MembershipCard_${member.member_id}.pdf`);
}
